
import React, { Component } from 'react';
import { ArcaUtil } from '../../../code/ArcaUtil';
import { PhotoPanel } from './PhotoPanel';
import { PhotoUploadPanel } from './PhotoUploadPanel';
import { LoadingPanel } from '../LoadingPanel';


export class PhotoUploadAndShowPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            imageKey: ArcaUtil.RandomString(5),
            isLoading: false
        };
    }

    render() {

        let { imageKey, isLoading } = this.state;
        let { id, folder } = this.props;

        let message = folder === 'walker'
            ? <p>Please upload a photograph you like of yourself</p>
            : folder === 'hint'
                ? <p>Please upload a picture that may help the team locate your key safe or front door.</p>
                : <p>Please upload a picture</p>

        return (
            <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
                <h1>Image Uploader</h1>
                {message}

                <PhotoUploadPanel
                    folder={folder}
                    id={id}
                    uploadStarted={() => this.setState({ isLoading: true })}
                    imageUpdated={(() => this.setState({ imageKey: ArcaUtil.RandomString(5), isLoading: false }))} />

                {isLoading
                    ? <LoadingPanel />
                    : <PhotoPanel
                        id={id}
                        folder={folder}
                        key={imageKey} />}

            </div>
        );
    }
}